<div width="100%" height="100%">
  <wiz-group  width="100%" height="100%">
    <smallargs-renderer #argRender width="100%" height="100%" [data]="argData"></smallargs-renderer>
    <wiz-group  width="100%" height="100%" *ngIf="_templatingMode">
      <wiz-hgroup width="100%" horizontalAlign="end" class="freedata-gridster-header" gap="0" >
        <wiz-icon #icoSettings style="cursor: pointer;" class="image-purple smallMe"  [wizTooltip]="'$.common.showsettings.$'"
          (click)="onSettings()">settings </wiz-icon>
        <wiz-icon  style="cursor: pointer;" class="image-purple smallMe"  [wizTooltip]="'$.common.delete.$'"  (click)="onDeleteClick()">delete </wiz-icon>
      </wiz-hgroup>
    </wiz-group>
  </wiz-group>
  
  
</div>
